import { Fragment, useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import BodyMid from "./BodyMid"
import BodyRight from "./BodyRight"
import FooterRight from "../Footer/FooterRight"
import Footer from "../Footer/Footer"
import { getColor } from "helpers/utilities"
import { RadialBarChart } from "components/Common"
import { Card, CardBody, CardHeader } from "reactstrap"

const Body = ({ data }) => {
  const [bodyData, setBodyData] = useState({})
  const [rateOfResultsByCategory, setRateOfResultsByCategory] = useState([])

  useEffect(() => {
    setBodyData(data)
    setRateOfResultsByCategory(data.rateOfResultsByCategory)
    console.log("🚀 ~ Body ~ bodyData:", bodyData)
  }, [data])

  return (
    <Fragment>
      <Row className="general-dashboard-body">
        <Col lg="8" style={{
          height: 'auto',
          minHeight: 'calc(100vh - 180px)',
          maxHeight: 'none'
        }}>
          <Row>
            <Col lg="6">
              <BodyMid statusInstruments={bodyData?.statusInstruments || []} />
            </Col>
            <Col lg="6">
              <BodyRight
                data={{
                  stateSample: bodyData?.stateSample,
                  rateOfResultsByCategory: bodyData?.rateOfResultsByCategory
                }} />
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Footer
                data={{
                  totalSampleDaily: data?.totalSampleDaily || {},
                  dailySampleDensity: data?.dailySampleDensity || {}
                }}
              />
            </Col>

            <Col lg="12" style={{
              height: 'auto',
              minHeight: '200px',
              marginTop: '15px'
            }}>
              <Card className="mb-2" style={{
                height: "auto",
                minHeight: "200px"
              }}>
                <CardHeader
                  style={{
                    textAlign: "center",
                    background: "#fff",
                    paddingBottom: 0,
                  }}
                >
                  <div style={{ fontSize: 15, fontWeight: 600 }}>Tỷ lệ có kết quả</div>
                </CardHeader>
                <CardBody
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 0,
                    flexWrap: "wrap",
                    gap: "10px",
                    minHeight: "150px",
                    alignItems: "center"
                  }}
                >
                  {rateOfResultsByCategory.map((item, index) => (
                    <div key={index} style={{
                      flex: "1 1 auto",
                      minWidth: "120px",
                      textAlign: "center"
                    }}>
                      <RadialBarChart data={item} color={getColor(index)} height={80} />
                      <div style={{
                        textAlign: "center",
                        fontSize: "12px",
                        marginTop: "5px"
                      }}>
                        {item.category} - {item.percentage}%
                      </div>
                    </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col lg="4" style={{
          height: 'auto',
          minHeight: 'calc(100vh - 180px)',
          maxHeight: 'none'
        }}>
          <FooterRight />
        </Col>
      </Row>

    </Fragment>
  )
}

export default Body
